/**
 * Hier liegt das Template, dass für Facebookposts im Bereich Overview genutzt wird
 */

import React, { useEffect, useState } from 'react'

import { Divider, Grid } from '@mui/material'

import { PostingTemplate, ScreenEnum, ViewEnum, } from '@professocial/professocialTypes/types/commonTypes'

import FBProfileImage from '../../../shared/components/ModuleComponents/Preview/modules/facebook/FBProfileImage'
import Headline from '../../../shared/components/ModuleComponents/Post/modules/Headline'
import FBSubHeadline from '../../../shared/components/ModuleComponents/Preview/modules/facebook/FBSubHeadline'
import LikePreview from '../../../shared/components/ModuleComponents/Preview/modules/shared/LikePreview'
import SharePreview from '../../../shared/components/ModuleComponents/Preview/modules/shared/SharePreview'
import ShowCommentsPreview from '../../../shared/components/ModuleComponents/Preview/modules/shared/ShowCommentsPreview'
import CommentsPreview from '../../../shared/components/ModuleComponents/Preview/modules/shared/CommentsPreview'
import PostContentPreview from '../../../shared/components/ModuleComponents/Preview/modules/shared/PostContentPreview'

import getDateFormat from '../../../defaults/getDateFormat'
import formatDate from '@professocial/professocialFormComponents/FormComponents/util/formatDate'
import { IFacebookPostProps } from './FacebookPostTemplate'
import { useSelector } from 'react-redux'
import { NetworkType } from '@3m5/sm_publish-frontend-api'
import { getPostingConfiguration } from '../../../store/common/common.selectors'
import { PostingConfiguration } from '@professocial/professocialTypes'

const FacebookPreview: React.FC<IFacebookPostProps> = (props: IFacebookPostProps) => {
  const view = props.view || ViewEnum.overview
  const size = props.size || ScreenEnum.xl

  const postingConfiguration: PostingConfiguration | undefined = useSelector(getPostingConfiguration)

  const [post, setPost] = useState<PostingTemplate>(props.post as PostingTemplate)

  const networkType: NetworkType = props.networkType || NetworkType.Facebook
  const { facebookPage } = postingConfiguration?.networkPage || {}

  useEffect(() => {
    setPost(props.post as PostingTemplate)
  }, [props.post])

  return (
    <>
      <Grid container>
        <Grid item xs='auto'>
          <FBProfileImage
            data={props.networkPageId ? `https://graph.facebook.com/${props.networkPageId}/picture` : 'noimage'}
            view={props.view}
          />
        </Grid>
        <Grid item xs={9} container>
          <Grid item xs={12}>
            <Headline
              post={post}
              networkType={networkType}
              value={facebookPage ? (facebookPage.pageUserName || facebookPage.pageName) : ''}
              view={view}
              size={size}
            />
          </Grid>
          <Grid item xs={12}>
            <FBSubHeadline
              post={post}
              networkType={networkType}
              value={formatDate(new Date().getTime(), getDateFormat('dateTime'))}
              view={view}
              size={size}
            />
          </Grid>
        </Grid>
        <Grid xs={12} item>
          <PostContentPreview
            networkPageId={props.networkPageId}
            post={post}
            networkType={networkType}
            value={post}
            view={view}
            size={size}
          />
        </Grid>
        <Grid xs={12} item>
          <Divider variant='middle' />
        </Grid>
        <Grid xs={4} item>
          <LikePreview
            post={post}
            networkType={networkType}
            value={post}
            view={view}
            size={size}
          />
        </Grid>
        <Grid xs={4} item>
          <ShowCommentsPreview
            post={post}
            networkType={networkType}
            value={post}
            view={view}
            size={size}
          />
        </Grid>
        <Grid xs={4} item>
          <SharePreview
            post={post}
            networkType={networkType}
            value={post}
            view={view}
            size={size}
          />
        </Grid>
        <Grid xs={12} item>
          <Divider variant='middle' />
        </Grid>
        <Grid xs={12} item>
          <CommentsPreview
            post={post}
            networkType={networkType}
            value={post}
            view={view}
            size={size}
          />
        </Grid>
      </Grid>
    </>
  )
}

export default FacebookPreview
